'use client';
import { useMergeRefs } from '@floating-ui/react';
import { useId, useContext, useMemo, useEffect } from 'react';
import { useDebounceCallback } from '../../../utilities/hooks/deprecated/use-debounce-callback/use-debounce-callback.js';
import '@digdir/designsystemet-web';
import '../../../utilities/roving-focus/roving-focus-item.js';
import '../../../utilities/roving-focus/roving-focus-root.js';
import { ComboboxContext } from '../ComboboxContext.js';
import { useComboboxId, useComboboxIdDispatch } from '../ComboboxIdContext.js';
import { prefix } from '../utilities.js';

const useComboboxOption = ({ id, ref, value, }) => {
    const generatedId = useId();
    const newId = id || generatedId;
    const context = useContext(ComboboxContext);
    const { activeIndex } = useComboboxId();
    const dispatch = useComboboxIdDispatch();
    if (!context) {
        throw new Error('ComboboxOption must be used within a Combobox');
    }
    const { selectedOptions, onOptionClick, setListRef, customIds, filteredOptions, } = context;
    const index = useMemo(() => filteredOptions.indexOf(prefix(String(value))) + customIds.length, [customIds.length, filteredOptions, value]);
    const combinedRef = useMergeRefs([
        (node) => {
            setListRef(index, node);
        },
        ref,
    ]);
    if (index === -1) {
        throw new Error('Internal error: ComboboxOption did not find index');
    }
    const selected = selectedOptions[prefix(value)];
    const active = activeIndex === index;
    useEffect(() => {
        if (active) {
            dispatch?.({ type: 'SET_ACTIVE_INDEX', payload: index });
        }
    }, [generatedId, id, dispatch, active, index]);
    const onOptionClickDebounced = useDebounceCallback(() => onOptionClick(value), 50);
    return {
        id: newId,
        ref: combinedRef,
        selected,
        active,
        onOptionClick: onOptionClickDebounced,
    };
};

export { useComboboxOption };
